export const words = {
  place: "Localização",
  yes: "Sim",
  no: "Não",
  new: "Novo",
  agb: "GTC",
  agb_full: "Termos e condições gerais",
  datenschutzerklaerung: "Política de privacidade",
  status: "Estado",
  company_name: "Nome da empresa",
  next_button: "Mais",
  device_name: "Nome do dispositivo",
  to_connect: "Ligar",
  pin: 'PIN',
  time: "Tempo",
  first_name: "Nome próprio",
  last_name: "Apelido",
  code: "Código",
  help: "Ajuda",
  total_time: "Tempo total",
  latitude: "Latitude",
  longitude: "Longitude",
  accuracy: "Exatidão",
  timestamp: "Carimbo de data/hora",
  device_id: "ID do dispositivo",
  active: "ativo",
  o_clock: "Relógio",
  loading: "Carregamento",
  annotation: "Observação",
  since: "desde",
  camera: "Câmara",
  map: "Mapa",
  gallery: "Galeria",
  work: "Trabalho",
  employees: "Colega",
  login: "Iniciar sessão",
  login_action: "Iniciar sessão",
  calendar_week_abbreviation: 'KW',
  calendar: "Calendário",
  to_call: "Chamada",
  email: "correio eletrónico",
  attachment: "Apêndice",
  operational_planning: "Plano operacional",
  to_scan: "Digitalização",
  download: "Descarregar",
  export: "Exportação",
  to_document: "Documento",
  checklist: "Lista de controlo",
  checklists: "Listas de controlo",
  password: "palavra-passe",
  confirmation: "Confirmação",
  confirm: "Confirmar",
  confirmation_email: "Correio de confirmação",
  unknown: "Desconhecido",
  unknown_place: "Localização desconhecida",
  unknown_plan: "Horário de turnos sem nome",
  project_no: "Projeto nº.",
  project_file: "Ficheiro de projeto",
  contact_person: "Pessoa de contacto",
  overtime: "Horas extraordinárias",
  timesheet: "Horário",
  minustime: "Menos horas",
  back: "Voltar",
  undo: "Anular",
  clockout: "Carimbar",
  clocked_out: "carimbado",
  clockin: "Estampagem",
  clocked_in: "carimbado",
  dismiss: "Cancelar",
  discard: "Rejeitar",
  finish: "Pronto",
  or: "ou",
  copy: "Copiar",
  qr_code: "Código QR",
  documentation: "Registo de tempo e documentação",
  attendance: "Terminal para tablet",
  tiercontent: "Âmbito do pacote",
  start_now: "Começar agora",
  skip: "Saltar",
  logout_during_core_time: "Esgotado durante o período de referência",
  absent_during_core_time: "Ausente durante o tempo central",
  distance: "Distância",
  km_reading: "Quilometragem",
  the_start: "Início",
  the_end: "Fim",
  license_plate: "Matrícula",
  details: "pormenores",
  hide: "esconder",
  cost: "Custos",
  file: "Ficheiro",
  address_book: "Livro de endereços",
  template_plural: "Modelos",
  signature: "Assinatura",
  main_project: "Projeto principal",
  main_projects: "Principais projectos",
  sub_projects: "Subprojectos",
  scan_to_login_header: "Registo do código QR",
  description: "Descrição da",
  project_location: "Localização do projeto",
  phone_number: "Número de telefone",
  project_info: "Informações sobre o projeto",
  number_short: "Não.",
  sketch: "Esboço",
  video: "Vídeo",
  delete: "Suprimir",
  send: "Enviar",
  sending: "Enviar...",
  save: "Guardar",
  granted: "autorizado",
  pending: "solicitado",
  denied: "Rejeitado",
  customer: "Cliente",
  mobile_number: "Número de telefone",
  ok: 'Ok',
  day: "Dia",
  tomorrow: "Manhã",
  days: "Dias | Dia | Dias",
  holidays: "Feriados públicos",
  vacation_days: "Dias de férias",
  vacation_hours: "Horas de férias",
  request: "Aplicação",
  accept: "Aceitar",
  withdraw: "Retirar",
  hour_account: "Conta horária",
  period: "Período",
  to: "até",
  date: "Data",
  number: "Quantidade",
  message: "Mensagem",
  change: "Alterar",
  changed: "Alterado",
  changed_fields: "Mudança de campo",
  type: "Tipo",
  hour: "Hora",
  hours: "Horas",
  hours_abbreviation: "Horas.",
  hours_with_amount: "{amount} Horas",
  end: "acabamento",
  end_date: "Data final",
  start_date: "Data de início",
  absence: "Ausência",
  month: "Mês",
  week: "Semana",
  transcript: "Transcrição",
  time_left: "remanescente",
  transcript_tasks: "Tarefas",
  add_task: "Novo",
  /** Differentiation in some languages (e.g. English) */
  from: "de",
  of: "de",
  of_hours: "a partir de {hours} horas",
  of_hours_abbreviation: "a partir de {hours} hrs.",
  /**************/

  used: "utilizado",
  update: "Atualizar",
  today: "hoje",
  correction: "Correção",
  work_time: "Horário de trabalho",
  break: "Intervalo",
  loading_time: "Tempo de carregamento",
  driving_time: "Duração do trajeto",
  business_trip: "Viagem de negócios",
  project: "Projeto",
  special_one: "Especial1",
  special_two: "Especial2",
  clock: "Relógio",
  search: "Pesquisar",
  operation: "Atividade",
  day_protocol: "Registo diário",
  continue: "mais",
  total_duration: "Tempo total",
  duration: "Duração",
  hello: "Olá",
  close: "fechar",
  comment: "Comentário",
  small: "pequeno",
  medium: "médio",
  large: "Grande",
  sharpie: "Caneta",
  line: "Linha",
  arrow: "Seta",
  rectangle: "Retângulo",
  ellipse: "Elipse",
  text: "Texto",
  language_settings: "Definições de idioma",
  clock_reminder: "Lembrete de carimbo",
  individually: "Individual",
  from_o_clock: "de",
  to_o_clock: "até",
  eraser: "Borracha",
  edit: "Editar",
  legal_notes: "Assuntos jurídicos",
  notes: "Notas",
  note: "Nota",
  imprint: "Impressão",
  open_source_licenses: "Termos da licença de fonte aberta",
  author: 'Autor',
  license_type: "Tipo de licença",
  version: "Versão",
  substitute: "Representação",
  not_rated: "Não classificado",
  weekly_working_hours: "Horário de trabalho semanal",
  show_less: "Mostrar menos",
  office_center: "Centro de Escritórios",
  admin_view: "Gestão NFC",
  register: "Registo",
  shifts: {
    shift_attachments: "Anexos (camada)",
    shift_plan_attachments: "Anexos (plano de turnos)",
    shift_plan: "Horário de turnos",
    shift: "Camada"
  },
  absences: {
    sick: "Doença (continuação do pagamento do salário)",
    vacation: "Férias",
    workshop: "Seminário/curso",
    special_vacation: "Licença especial",
    school: "Escola",
    working_time_account: "Conta de tempo de trabalho",
    holiday: "Feriado",
    other: "Diversos",
    driving_time: "Duração do trajeto",
    parental_leave: "Licença parental",
    excused_absent: "Ausência justificada (remunerada)",
    not_excused_absent: "Ausência injustificada",
    sick_industrial_accident: "Doença Acidente de trabalho (LFZ)",
    short_time_work: "Trabalho a tempo reduzido (Kug)",
    maternity_pay: "Proteção da maternidade/ proibição de emprego",
    sick_child: "Cuidar de um filho doente com subsídio de doença (diário)",
    sick_child_no_payment: "Cuidar de um filho doente sem subsídio de doença (diário)",
    vacation_no_payment: "Férias não remuneradas",
    sick_before_short_time_work: "Subsídio de doença/doença antes do Kug",
    weather_related_failure: "Cancelamento devido a condições climatéricas",
    sick_short_time_work: "Doença durante o Kug",
    sick_no_payment: "Doença (sem continuação do pagamento do salário)",
    company_vacation: "Férias na empresa",
    meals_14_euro: "Pequeno subsídio de restauração",
    meals_28_euro: "Grande subsídio de restauração"
  },
  image_editor: {
    font_size: "Tamanho da letra",
    stroke_width: "Espessura da linha",
    stroke_color: "Cor da linha",
    text_color: "Cor da letra",
    rotate_left: "Virar para a esquerda",
    rotate_right: "Virar à direita",
    flip_horizontal: "Espelho na horizontal",
    flip_vertical: "Espelho na vertical"
  },
  travel_log: {
    method_of_transportation: "Meios de transporte",
    company_car: "Carro da empresa",
    private_car: "Automóvel particular",
    rental_car: "Aluguer de automóveis",
    taxi: "Táxi",
    public_transportation: "Transportes públicos",
    airplane: "Avião",
    train: "Caminho de ferro (transporte público de longa distância)",
    other: "Outros",
    km_reading_start: "Início da quilometragem",
    km_reading_end: "Fim da quilometragem",
    net_expenses: "Despesas de deslocação (líquidas)",
    tax: "Imposto sobre o valor acrescentado"
  },
  read_in: "Ler em",
  currency: "Moeda",
  reason: "Motivo",
  label: "Etiqueta",
  monday: "Segunda-feira",
  tuesday: "Terça-feira",
  wednesday: "Quarta-feira",
  thursday: "Quinta-feira",
  friday: "Sexta-feira",
  saturday: "Sábado",
  sunday: "Domingo",
  break_alarm: "Quebrar despertador",
  clockin_reminder: "Lembrete de entrada do ponto",
  clockout_reminder: "Lembrete de cancelar subscrição"
};